export const API_URL = process.env.NODE_ENV === 'production' 
  ? 'https://ai-assisted-game.onrender.com'
  : 'http://127.0.0.1:5000';

export const API_ENDPOINTS = {
  login: `${API_URL}/auth/login`,
  register: `${API_URL}/auth/register`,
}; 